import React, { Fragment, useEffect, useState } from "react";
import "./testLibrary.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  getDatabaseQuestionLanguages,
  resetDatabaseQuestions,
  getDefaultDatabaseQuestions,
  getQuestionLevels,
  removeFromSelectDatabase,
  createDatabaseTest,
  resetTestDetails,
} from "../../Redux/ActionCreators/testLibraryAction";
import CreateDatabaseQuestions from "../CreateDatabaseQuestions/createDatabaseQuestions";
import { ThreeDots } from "../../Loader/loader";
import Select from "react-select";
import { getTotal } from "../../utils/miscelleneous";
import { returnErrors } from "../../Redux/ActionCreators/errorAction";
import { Dialog } from "@mui/material";
import DatabaseQuestionList from "../CreateDatabaseQuestions/databaseQuestionList";
import { Modal } from "react-bootstrap";

export default function SelectDatabaseTest(props) {
  const [testLevel, setTestLevel] = useState("");
  const [databaseLanguage, setDatabaseLanguage] = useState([]);
  const [loadQues, setLoadQues] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isList, setIsList] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [details, setDetails] = useState("");
  const [time, setTime] = useState(10);
  const [score, setScore] = useState(20);
  const [isLoadingQuestions, setIsLoadingQuestions] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [testName, setTestName] = useState("");
  const [programmingLanguages, setProgrammingLanguages] = useState([]);

  const {
    questionLevel,
    dbTags,
    databaseQuestionByIdResponse,
    loadingDatabaseQuestionById,
  } = useSelector((state) => state.testLibrary);

  useEffect(() => {
    if (!isAdd || isAdd) {
      dispatch(getDatabaseQuestionLanguages());
      dispatch(getQuestionLevels());
      setProgrammingLanguages({
        label: props.langId?.displayLanguage,
        value: props.langId?.id,
      });
    }
  }, []);

  useEffect(() => {
    if (props.edit && databaseQuestionByIdResponse) {
      setIsAdd(false);
      setLoadQues(true);
      setTestName(databaseQuestionByIdResponse?.testName);
      setTestLevel(databaseQuestionByIdResponse?.testLevelId);
      setProgrammingLanguages({
        label: databaseQuestionByIdResponse?.languages[0]?.displayLanguage,
        value: databaseQuestionByIdResponse?.languages[0]?.codingLanguageId,
      });
    }
  }, [props.edit]);

  const dispatch = useDispatch();

  const {
    databaseQuestionLanguagesOptions,
    selectedDatabaseQuestion,
    loadingDatabaseQuestion,
  } = useSelector((state) => state.testLibrary);

  useEffect(() => {
    dispatch(resetDatabaseQuestions());
    setLoadQues(false);
    setIsList(false);
  }, []);

  useEffect(() => {
    dispatch(getDatabaseQuestionLanguages());
    dispatch(getQuestionLevels());
    setDatabaseLanguage({
      label: props.langId?.displayLanguage,
      value: props.langId?.id,
    });
  }, []);

  const selectLanguage = (e) => setDatabaseLanguage(e);
  const selectLevel = (val) => setTestLevel(val);

  const loadQuestions = async () => {
    setIsLoadingQuestions(true);
    await setLoadQues(true);
    await dispatch(resetDatabaseQuestions());
    const res = await dispatch(
      getDefaultDatabaseQuestions(testLevel, databaseLanguage?.value)
    );
    if (res?.type === "DEFAULT_DATABASE_QUESTION") {
      setIsLoadingQuestions(false);
      setLoadQues(true);
    } else {
      setIsLoadingQuestions(false);
    }
  };

  const removeQuestion = (question) => {
    dispatch(removeFromSelectDatabase(question));
  };

  const saveTest = async () => {
    await setLoading(true);
    if (!databaseLanguage?.value) {
      returnErrors(dispatch, "Database Language is required!", 500);
      setLoading(false);
      return;
    }
    if (!testLevel) {
      returnErrors(dispatch, "Test Level is required!", 500);
      setLoading(false);
      return;
    }
    if (!selectedDatabaseQuestion?.length) {
      returnErrors(dispatch, "Select at least one question", 500);
      setLoading(false);
      return;
    }

    let obj = {
      name: `${databaseLanguage?.label}-${testLevel} Database Test`,
      duration: getTotal(selectedDatabaseQuestion, "duration"),
      questionCount: selectedDatabaseQuestion?.length,
      testLevel: parseInt(testLevel),
      languageIds: [databaseLanguage?.value],
      questions: selectedDatabaseQuestion?.map((el) => ({
        questionId: el.id,
        duration: el.duration,
        score: el.score,
      })),
    };

    const res = await dispatch(createDatabaseTest(obj));
    if (res?.type === "CREATE_DATABASE_TEST") props.goToTest();
    setLoading(false);
  };

  const openEdit = (data) => {
    setIsEdit(true);
    setDetails(data);
    setTime(data.duration);
    setScore(data.score);
  };

  const editDatabaseQuestion = () => {
    if (time === "") {
      returnErrors(dispatch, `Time can't be empty`, 500);
    } else if (score === "") {
      returnErrors(dispatch, `Score can't be empty`, 500);
    } else {
      const obj = {
        id: details.id,
        duration: parseInt(time),
        score: parseInt(score),
      };
      dispatch({ type: "EDIT_DATABASE_QUESTION", payload: obj });
      setIsEdit(false);
    }
  };

  const openAdd = async () => {
    await setIsAdd(true);
  };

  const openList = () => {
    setIsList(true);
  };

  const goBack = () => {
    setIsAdd(false);
  };

  return (
    <div className="coding-test-container">
      <Dialog open={loading}>Loading...</Dialog>
      {isList ? (
        <DatabaseQuestionList
          backToAdd={() => setIsList(false)}
          testLevel={testLevel}
          language={databaseLanguage?.value}
          questions={selectedDatabaseQuestion}
          saveSelectQuestion={(ques) => {
            dispatch({
              type: "SAVE_SELECT_DATABASE_QUESTION",
              payload: ques,
            });
            setIsList(false);
          }}
        />
      ) : !isAdd ? (
        <>
          <Fragment>
            <div className="coding-header">
              <img
                src="/images/back.svg"
                alt=""
                className="cursor-pointer"
                onClick={() => {
                  dispatch(resetDatabaseQuestions());
                  props.goToTest();
                }}
              />
              &nbsp;&nbsp;
              <div>
                <h3>Database Test</h3>
                <p>Select language and level to generate a test</p>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Database Language</label>
                <Select
                  className="mt-2"
                  options={databaseQuestionLanguagesOptions?.map((el) => ({
                    label: el.displayLanguage,
                    value: el.id,
                  }))}
                  value={databaseLanguage}
                  onChange={(e) => selectLanguage(e)}
                />
              </div>
              <div className="col-md-6">
                <label>Test Level</label>
                <select
                  className="form-control mt-2"
                  value={testLevel}
                  onChange={(e) => selectLevel(e.target.value)}
                >
                  <option hidden>Select Level</option>
                  <option value={1}>Beginner</option>
                  <option value={3}>Intermediate</option>
                  <option value={2}>Advanced</option>
                </select>
              </div>
            </div>
            <button
              className="load-btn mt-3"
              disabled={!testLevel || !databaseLanguage?.value}
              onClick={loadQuestions}
            >
              Load Questions
            </button>
          </Fragment>
          {isLoadingQuestions ? (
            <div className="loading-overlay" style={{ height: "300px" }}>
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : loadQues ? (
            <div className="coding-question-list mt-4">
              <div className="list-header">
                <div>
                  <h5>Database Questions</h5>
                  <p>
                    {selectedDatabaseQuestion?.length} Questions |{" "}
                    {getTotal(selectedDatabaseQuestion, "duration")} mins
                  </p>
                </div>
                <div>
                  <button className="outline-btn" onClick={() => openList()}>Add Question From List</button>&nbsp;&nbsp;
                  <button className="outline-btn" onClick={() => openAdd()}>Add New Question</button>
                </div>
              </div>

              <div className="count-header">
                <div className="d-flex align-items-center">
                  <h4>Question</h4>&nbsp;
                  <span>{selectedDatabaseQuestion?.length}</span>
                </div>
                <div className="d-flex align-items-center">
                  <h4>Time(mins)</h4>&nbsp;
                  <span>{getTotal(selectedDatabaseQuestion, "duration")}</span>
                </div>
                <div className="d-flex align-items-center">
                  <h4>Score</h4>&nbsp;
                  <span>{getTotal(selectedDatabaseQuestion, "score")}</span>
                </div>
              </div>

              {loadingDatabaseQuestion ? (
                <ThreeDots />
              ) : selectedDatabaseQuestion?.length > 0 ? (
                <div className="lists">
                  {selectedDatabaseQuestion.map((el, i) => (
                    <div key={el.id} className="question-list">
                      <div>Q {i + 1}</div>&nbsp;&nbsp;&nbsp;
                      <div>{el.name}</div>
                      <div>{el.difficultyLevelName}</div>
                      {window.innerWidth > 767 && <div>{el.duration} Mins</div>}
                      {window.innerWidth > 767 && <div>Score: {el.score}</div>}
                      <div style={{ color: "#F75891" }}>
                        <img
                          src="/images/edit-icon.svg"
                          className="cursor-pointer"
                          onClick={() => openEdit(el)}
                          alt="edit"
                        />
                        &nbsp;
                        {window.innerWidth > 767 && "EDIT"}
                      </div>
                      <div>
                        <img
                          src="/images/delete-icon.svg"
                          alt="delete"
                          className="cursor-pointer"
                          onClick={() => removeQuestion(el)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-list">
                  <img src="/images/magnifier.svg" alt="" />
                  <div className="mt-2">
                    <h3 style={{ color: "black" }}>No question found</h3>
                  </div>
                </div>
              )}
              <button className="save-btn mt-3" onClick={saveTest}>
                Save and Continue
              </button>
            </div>
          ) : null}
        </>
      ) : isAdd ? (
        <CreateDatabaseQuestions goBack={goBack} addFromList={true} />
      ) : null}
      <Modal
        show={isEdit}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName={"edit-modal"}
      >
        <div className="sticky-holder" onClick={() => setIsEdit(false)}>
          <img src="/images/close.svg" alt="close" />
        </div>
        <div className="p-4">
          <h2>Edit Database Question</h2>
          <p>Select the below options to continue</p>

          <div className="mt-2">
            <div className="form-group mt-3">
              <label>Question Time (mins)</label>
              <div className="items">
                <div
                  className={time === details.duration ? "item active" : "item"}
                  onClick={() => setTime(time)}
                >
                  {details.duration}
                </div>
                <div>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Custom"
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="form-group mt-3">
              <label>Question Score</label>
              <div className="items">
                <div
                  className={score === details.score ? "item active" : "item"}
                  onClick={() => setScore(score)}
                >
                  {details.score}
                </div>
                <div>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Custom"
                    value={score}
                    onChange={(e) => setScore(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="save-btn">
            <button onClick={editDatabaseQuestion}>CONTINUE</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
